var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMappingDeleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 142,
    viewBox: "0 0 118 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7347 132.735C91.173 132.735 117.469 106.439 117.469 74.0003C117.469 41.562 91.173 15.2656 58.7347 15.2656C26.2964 15.2656 0 41.562 0 74.0003C0 106.439 26.2964 132.735 58.7347 132.735Z",
    fill: "url(#paint0_linear_4723_28269)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4723_28269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.4093 48.9375H25.0602C22.8976 48.9375 21.1445 50.6906 21.1445 52.8531V135.082C21.1445 137.244 22.8976 138.997 25.0602 138.997H92.4093C94.5719 138.997 96.325 137.244 96.325 135.082V52.8531C96.325 50.6906 94.5719 48.9375 92.4093 48.9375Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9022 60.6875H30.5408C29.2433 60.6875 28.1914 61.7394 28.1914 63.0369C28.1914 64.3344 29.2433 65.3863 30.5408 65.3863H50.9022C52.1997 65.3863 53.2515 64.3344 53.2515 63.0369C53.2515 61.7394 52.1997 60.6875 50.9022 60.6875Z",
    fill: "#D0D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9985 70.8672H30.5408C29.2433 70.8672 28.1914 71.919 28.1914 73.2166C28.1914 74.5141 29.2433 75.566 30.5408 75.566H64.9985C66.296 75.566 67.3479 74.5141 67.3479 73.2166C67.3479 71.919 66.296 70.8672 64.9985 70.8672Z",
    fill: "#EAECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9022 81.8281H30.5408C29.2433 81.8281 28.1914 82.88 28.1914 84.1775C28.1914 85.475 29.2433 86.5269 30.5408 86.5269H50.9022C52.1997 86.5269 53.2515 85.475 53.2515 84.1775C53.2515 82.88 52.1997 81.8281 50.9022 81.8281Z",
    fill: "#D0D5DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9985 92.0078H30.5408C29.2433 92.0078 28.1914 93.0597 28.1914 94.3572C28.1914 95.6547 29.2433 96.7066 30.5408 96.7066H64.9985C66.296 96.7066 67.3479 95.6547 67.3479 94.3572C67.3479 93.0597 66.296 92.0078 64.9985 92.0078Z",
    fill: "#EAECF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9022 102.977H30.5408C29.2433 102.977 28.1914 104.028 28.1914 105.326C28.1914 106.623 29.2433 107.675 30.5408 107.675H50.9022C52.1997 107.675 53.2515 106.623 53.2515 105.326C53.2515 104.028 52.1997 102.977 50.9022 102.977Z",
    fill: "#D0D5DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9985 113.156H30.5408C29.2433 113.156 28.1914 114.208 28.1914 115.506C28.1914 116.803 29.2433 117.855 30.5408 117.855H64.9985C66.296 117.855 67.3479 116.803 67.3479 115.506C67.3479 114.208 66.296 113.156 64.9985 113.156Z",
    fill: "#EAECF0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4723_28269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.4093 9H25.0602C22.8976 9 21.1445 10.7531 21.1445 12.9156V36.4095C21.1445 38.5721 22.8976 40.3252 25.0602 40.3252H92.4093C94.5719 40.3252 96.325 38.5721 96.325 36.4095V12.9156C96.325 10.7531 94.5719 9 92.4093 9Z",
    fill: "#98A2B3"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9022 17.6172H30.5408C29.2433 17.6172 28.1914 18.669 28.1914 19.9666C28.1914 21.2641 29.2433 22.316 30.5408 22.316H50.9022C52.1997 22.316 53.2515 21.2641 53.2515 19.9666C53.2515 18.669 52.1997 17.6172 50.9022 17.6172Z",
    fill: "#EAECF0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9985 27.7969H30.5408C29.2433 27.7969 28.1914 28.8487 28.1914 30.1463C28.1914 31.4438 29.2433 32.4957 30.5408 32.4957H64.9985C66.296 32.4957 67.3479 31.4438 67.3479 30.1463C67.3479 28.8487 66.296 27.7969 64.9985 27.7969Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4723_28269",
    x: 15.1445,
    y: 39.9375,
    width: 87.1797,
    height: 102.062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4723_28269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4723_28269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4723_28269",
    x: 15.1445,
    y: 0,
    width: 87.1797,
    height: 43.3281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4723_28269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4723_28269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4723_28269",
    x1: 58.7347,
    y1: 15.2656,
    x2: 58.7347,
    y2: 132.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAECF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECF0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappingDeleted);
export default __webpack_public_path__ + "static/media/MappingDeleted.80e9ee6f24ef910528c5cea55dfa158a.svg";
export { ForwardRef as ReactComponent };